/**
 * Páginas legales / del CMS: índice lateral, apartado activo y barra de lectura.
 *
 *   [data-legal-contenido]  HTML del CMS. Sus títulos de apartado son <h2> o
 *                           párrafos que solo contienen un <strong> (así los
 *                           escribe hoy el editor). Estos se marcan con
 *                           .legal-titulo para que el CSS los numere.
 *   [data-legal-indice]     <nav> donde se crea un enlace por apartado. Si no
 *                           hay apartados, se queda oculto.
 *   [data-legal-progreso]   Barra que crece con el scroll de la página.
 */

function esTituloEnParrafo(parrafo) {
    const fuerte = parrafo.querySelector(':scope > strong:only-child');
    return fuerte !== null && fuerte.textContent.trim() === parrafo.textContent.trim() && parrafo.textContent.trim() !== '';
}

function aSlug(texto) {
    return texto
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}

function initLegal() {
    const contenido = document.querySelector('[data-legal-contenido]');
    if (!contenido) {
        return;
    }

    [...contenido.children]
        .filter((el) => el.tagName === 'P' && esTituloEnParrafo(el))
        .forEach((el) => el.classList.add('legal-titulo'));

    const titulos = [...contenido.querySelectorAll(':scope > h2, :scope > .legal-titulo')];
    const indice = document.querySelector('[data-legal-indice]');
    const enlaces = [];

    titulos.forEach((titulo, i) => {
        const texto = titulo.textContent.trim().replace(/[¿?:]/g, '').trim();
        if (!titulo.id) {
            titulo.id = aSlug(texto) || `apartado-${i + 1}`;
        }

        if (!indice) {
            return;
        }

        const enlace = document.createElement('a');
        enlace.href = `#${titulo.id}`;
        enlace.className = 'legal-enlace -ml-0.5 flex gap-3 rounded-r-r2c border-l-2 border-transparent py-2.5 pr-3 pl-[18px] text-[15px] leading-snug font-medium text-fg-muted transition hover:bg-surface-3 hover:text-r2c-indigo aria-[current=true]:border-r2c-purple aria-[current=true]:bg-surface aria-[current=true]:font-semibold aria-[current=true]:text-r2c-indigo';

        const numero = document.createElement('span');
        numero.className = 'w-[22px] flex-none font-heading text-[13px] leading-[1.55] font-bold text-fg-ghost';
        numero.textContent = String(i + 1).padStart(2, '0');

        const nombre = document.createElement('span');
        nombre.textContent = titulo.textContent.trim();

        enlace.append(numero, nombre);
        indice.appendChild(enlace);
        enlaces.push(enlace);
    });

    if (indice && enlaces.length) {
        indice.hidden = false;
    }

    const progreso = document.querySelector('[data-legal-progreso]');

    const actualizar = () => {
        let activo = 0;
        titulos.forEach((titulo, i) => {
            if (titulo.getBoundingClientRect().top < window.innerHeight * 0.35) {
                activo = i;
            }
        });
        enlaces.forEach((enlace, i) => enlace.setAttribute('aria-current', i === activo ? 'true' : 'false'));

        if (progreso) {
            const recorrido = document.documentElement.scrollHeight - window.innerHeight;
            const avance = recorrido > 0 ? Math.min(100, Math.max(0, (window.scrollY / recorrido) * 100)) : 0;
            progreso.style.width = `${avance}%`;
        }
    };

    window.addEventListener('scroll', actualizar, { passive: true });
    actualizar();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLegal, { once: true });
} else {
    initLegal();
}
